/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CalendarSettingsPermissionEnum } from './CalendarSettingsPermissionEnum';
import {
    CalendarSettingsPermissionEnumFromJSON,
    CalendarSettingsPermissionEnumFromJSONTyped,
    CalendarSettingsPermissionEnumToJSON,
    CalendarSettingsPermissionEnumToJSONTyped,
} from './CalendarSettingsPermissionEnum';

/**
 * Request to update planning permission by institute
 * @export
 * @interface PlanningPermissionRequest
 */
export interface PlanningPermissionRequest {
    /**
     * 
     * @type {Array<CalendarSettingsPermissionEnum>}
     * @memberof PlanningPermissionRequest
     */
    access?: Array<CalendarSettingsPermissionEnum>;
}

/**
 * Check if a given object implements the PlanningPermissionRequest interface.
 */
export function instanceOfPlanningPermissionRequest(value: object): value is PlanningPermissionRequest {
    return true;
}

export function PlanningPermissionRequestFromJSON(json: any): PlanningPermissionRequest {
    return PlanningPermissionRequestFromJSONTyped(json, false);
}

export function PlanningPermissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanningPermissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'access': json['access'] == null ? undefined : ((json['access'] as Array<any>).map(CalendarSettingsPermissionEnumFromJSON)),
    };
}

export function PlanningPermissionRequestToJSON(json: any): PlanningPermissionRequest {
    return PlanningPermissionRequestToJSONTyped(json, false);
}

export function PlanningPermissionRequestToJSONTyped(value?: PlanningPermissionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'access': value['access'] == null ? undefined : ((value['access'] as Array<any>).map(CalendarSettingsPermissionEnumToJSON)),
    };
}

